/**
 * LumaPOS Admin — brand & layout tokens.
 * Light, airy workspace: soft grey canvas, borderless white cards, lime data colours and
 * near-black primary actions.
 */
export const brand = {
  tagline: 'Sell Smarter. Grow Faster.',
  /** Primary green (links, switches, checkboxes, active accents) */
  green: '#5C9E1E',
  greenBright: '#8DC63F',
  greenDark: '#457A12',
  lime: '#B5DB6A',
  /** Data palette (charts, progress, segments) */
  chartLime: '#8DC63F',
  chartLimeSoft: '#C9E59A',
  chartYellow: '#E9E35C',
  chartOrange: '#F4A462',
  chartGrey: '#ECEDEA',
  /** Kept as aliases so existing brand.blue / brand.pink call sites stay valid */
  blue: '#5C9E1E',
  blueBright: '#8DC63F',
  pink: '#8DC63F',
  slate: '#161916',
  slateElevated: '#202420',
  ink: '#161916',
  muted: '#73786F',
  canvas: '#F1F2EF',
  surface: '#FFFFFF',
  /** Subtle fill for hovered/selected items on white surfaces */
  subtle: '#F4F5F2',
  border: 'rgba(22, 25, 22, 0.07)',
  white: '#ffffff',
  success: '#4E9A1A',
  warning: '#E08A2E',
  error: '#D93A3A',
  info: '#2F7FC1',
  /** Primary call to action (dark buttons) */
  action: '#161916',
  actionHover: '#2C312B',
  radius: 16,
  radiusSm: 12,
  cardShadow: '0 1px 2px rgba(22, 25, 22, 0.03)',
  gradient: 'linear-gradient(135deg, #B5DB6A 0%, #8DC63F 55%, #5C9E1E 100%)',
  gradientSoft:
    'linear-gradient(180deg, rgba(141,198,63,0.08) 0%, transparent 100%)',
  gradientCardHeader: 'transparent',
  sidebarGradient: '#FFFFFF',
  sidebarGlow: 'none',
  logoSrc: '/static/images/status/lumapos-logo.png'
} as const;

export type Brand = typeof brand;
